import 'jquery-match-height';
import Swiper from 'swiper/js/swiper.min.js';

$('.js-article-gnav-toggle').click(function () {
  $(this).toggleClass('is-active');
  $('.js-article-gnav-toggle-target').toggleClass('is-active');
  removeMenuByClickingNotMenu();
});

$('.js-article-gnav-dropdown-toggle').click(function () {
  $(this).toggleClass('is-active');
  $(this).next('.js-article-gnav-dropdown-toggle-target').toggleClass('is-active');
  removeMenuByClickingNotMenu();
});

//メニュー以外をクリックしたらメニューを閉じる
function removeMenuByClickingNotMenu() {
  if ($('.js-article-gnav-toggle').hasClass('is-active') || $('.js-article-gnav-dropdown-toggle').hasClass('is-active')) {
    $(document).on('click touchend', function (e) {
      if (!$(e.target).closest('.js-article-gnav-toggle, .js-article-gnav-dropdown-toggle, .article-gnav__menu-link').length) {
        $('.js-article-gnav-toggle').removeClass('is-active');
        $('.js-article-gnav-toggle-target').removeClass('is-active');
        $('.js-article-gnav-dropdown-toggle').removeClass('is-active');
        $('.js-article-gnav-dropdown-toggle-target').removeClass('is-active');
      }
    });
  } else {
    $(document).off('click touchend');
  }
}

//会議弁当特集やランキング特集のドロップダウンメニュー
$('.js-dropdown').each(function(){
  let thisElement = $(this);
  thisElement.find('.js-dropdown-trigger').click(function () {
    $(this).toggleClass('is-active')
    thisElement.find('.js-dropdown-target').toggle(0);
  });
})

//ドロップダウンメニュー以外をクリックしたらドロップダウンを閉じる
$(document).on('click', function (e) {
  if (!$(e.target).closest('.js-dropdown-trigger, .js-dropdown-target').length) {
    $('.js-dropdown-trigger').removeClass('is-active');
    $('.js-dropdown-target').hide();
  }
});

//ドロップダウンメニューの中で現在のページがある場合にドロップダウンメニューボタンのテキストをそのメニュー名に変更する。
$('.js-change-dropdown-btn-to-current').each(function(){
  let thisElement = $(this);
  thisElement.find('a').each(function(){
    if(currentPath == $(this).attr('href')){
      thisElement.find('.js-dropdown-trigger').text($(this).text());
    }
  });
});

//グローバルメニューの中で現在のページのメニューにクラスをつける
const currentPath = location.pathname;
$('.js-current-menu-status a').each(function(){
  if (currentPath == $(this).attr('href')){
    $(this).addClass('is-current');
  }
});

// ----------------- modal
$('.js-modal').each(function(){
  let thisElement = $(this);
  thisElement.find('.js-modal-trigger').click(function () {
    let modal_id = $(this).data('modal-id');
    $('body').toggleClass('scroll-lock');
    $('.js-modal-target[data-modal-id=' + modal_id + ']').toggleClass('is-open');
  });
})

//ドロップダウンメニュー以外をクリックしたらドロップダウンを閉じる
$('.js-modal-close').on('click', function () {
  let modal_id = $(this).data('modal-id');
  if (modal_id) {
    $('.js-modal-target[data-modal-id=' + modal_id + ']').removeClass('is-open');
    $('body').removeClass('scroll-lock');
  }
});

//ドロップダウンメニューの中で現在のページがある場合にドロップダウンメニューボタンのテキストをそのメニュー名に変更する。
$('.js-change-modal-btn-to-current').each(function(){
  let thisElement = $(this);
  let modal_id = thisElement.data('modal-id');
  $('.js-modal-target[data-modal-id=' + modal_id + '] li').each(function(){
    let path = $(this).find('a');
    if(currentPath == path.attr('href')){
      thisElement.text($(path).text());
    }
  });
});
// ----------------- modal

$('.js-feature-area-links-toggle').click(function() {
  $(this).toggleClass('is-active');
  $(this).next('.js-feature-area-links-toggle-target').toggleClass('is-active');
});

$('.js-match-height-1').matchHeight();
$('.js-match-height-2').matchHeight();

$('.itemList-item').matchHeight();//花見特集用

$('.js-see-more').click(function(){
  $(this).hide();
  $('.js-see-more-target').addClass('is-active');
});

new Swiper('.js-swiper-container-1', {
  loop: true,
  effect: 'fade',
  autoplay: {
    delay: 5000,
  },
  speed: 2000,
  pagination: {
    el: '.js-swiper-pagination-1',
    clickable: true,
  },
});

new Swiper('.js-swiper-container-2', {
  spaceBetween: 16,
  autoplay: false,
  speed: 600,
  pagination: {
    el: '.js-swiper-pagination-2',
    clickable: true,
  },
  slidesPerView: 1.07,
  navigation: {
    nextEl: '.js-swiper-button-next-2',
    prevEl: '.js-swiper-button-prev-2',
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
    },
  },
});

new Swiper('.js-swiper-container-3', {
  slidesPerView: 1,
  spaceBetween: 16,
  autoplay: false,
  navigation: {
    nextEl: '.js-swiper-button-next-3',
    prevEl: '.js-swiper-button-prev-3',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
  },
});

$('.js-swiper-container-4').each(function(){
  let prevButton = $(this).find('.js-swiper-button-prev-4');
  let nextButton = $(this).find('.js-swiper-button-next-4');
  let mySwiper = new Swiper($(this).find('.swiper-container'), {
    slidesPerView: 2,
    spaceBetween: 16,
    autoplay: false,
    breakpoints: {
      768: {
        slidesPerView: 4,
      },
    },
    on: {
      init: function() {
        prevButton.addClass('swiper-button-disabled');
      },
      reachBeginning: function(){
        prevButton.addClass('swiper-button-disabled');
      },
      reachEnd: function () {
        nextButton.addClass('swiper-button-disabled');
      },
      fromEdge: function() {
        prevButton.removeClass('swiper-button-disabled');
        nextButton.removeClass('swiper-button-disabled');
      },
    },
  });
  prevButton.click(function(){
    mySwiper.slidePrev();
  });
  nextButton.click(function () {
    mySwiper.slideNext();
  });
});

$('.js-swiper-container-5').each(function () {
  let prevButton = $(this).find('.js-swiper-button-prev-5');
  let nextButton = $(this).find('.js-swiper-button-next-5');
  let mySwiper = new Swiper($(this).find('.swiper-container'), {
    slidesPerView: 2,
    spaceBetween: 16,
    autoplay: false,
    on: {
      init: function () {
        prevButton.addClass('swiper-button-disabled');
      },
      reachBeginning: function () {
        prevButton.addClass('swiper-button-disabled');
      },
      reachEnd: function () {
        nextButton.addClass('swiper-button-disabled');
      },
      fromEdge: function () {
        prevButton.removeClass('swiper-button-disabled');
        nextButton.removeClass('swiper-button-disabled');
      },
    },
  });
  prevButton.click(function () {
    mySwiper.slidePrev();
  });
  nextButton.click(function () {
    mySwiper.slideNext();
  });
});

$('.js-swiper-container-6').each(function () {
  let prevButton = $(this).find('.js-swiper-button-prev-6');
  let nextButton = $(this).find('.js-swiper-button-next-6');
  let mySwiper = new Swiper($(this).find('.swiper-container'), {
    slidesPerView: 1,
    spaceBetween: 16,
    autoplay: false,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
    on: {
      init: function () {
        prevButton.addClass('swiper-button-disabled');
      },
      reachBeginning: function () {
        prevButton.addClass('swiper-button-disabled');
      },
      reachEnd: function () {
        nextButton.addClass('swiper-button-disabled');
      },
      fromEdge: function () {
        prevButton.removeClass('swiper-button-disabled');
        nextButton.removeClass('swiper-button-disabled');
      },
    },
  });
  prevButton.click(function () {
    mySwiper.slidePrev();
  });
  nextButton.click(function () {
    mySwiper.slideNext();
  });
});

window.onload = function () {
  $('.mv-sozailabo__text, .mv-sozailabo__logo, .sozailabo-section-first-scene').addClass('is-active');
}

//会議弁当特集のセレクトメニュー
$('.js-select-menu').change(function(){
  window.location.href = $(this).val();
});

//フッターを非同期で表示する
$.ajax({
  type: 'POST',
  // eslint-disable-next-line no-undef
  url: ajaxObject.ajaxurl,
  data: {
    'action': 'get_footer_ajax',
  },
  success: function (response) {
    $('#footer-common').html(response);
  },
});



// WEBPACK FOOTER //
// ./scripts/page.js